import { atom } from 'jotai';

import { MedicineNotesContainerState } from './types';

export const medicineNotesContainerState = atom<MedicineNotesContainerState>({
  isDetailView: false,
});
